import React from "react";
import PrepDeckApp from "./components/PrepDeckApp";

function App() {
  return <PrepDeckApp />;
}

export default App;
